const SEVERITY_COLORS: any = {
    high: '#D50032',
    highmedium: '#F56811',
    medium: '#FFCD00',
    low: '#009639'
}


export const GET_ESCALATION_COLOR = (rating: string) => {
    switch (rating.toLowerCase()) {
        case 'high': return SEVERITY_COLORS.high;
        case 'high-medium': return SEVERITY_COLORS.highmedium;
        case 'medium': return SEVERITY_COLORS.medium;
        case 'low': return SEVERITY_COLORS.low;
    }
}



export const ESCALATION_PRIORITY_LEGENDS = ['HIGH', 'HIGH-MEDIUM', 'MEDIUM', 'LOW'];